import { Paper } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { CARD_BG } from '../utils/constants';

/** A card on the Team Workload page: grey fill, hairline border, rounded. */
export default function Panel({ children, sx, ...rest }) {
  return (
    <Paper variant="outlined" sx={{ borderRadius: 3, borderColor: WD.border, bgcolor: CARD_BG, ...sx }} {...rest}>
      {children}
    </Paper>
  );
}
